// Logo stripes: below 992px the stripe is duplicated so it can scroll seamlessly
// as a marquee. Clones are torn down again when the breakpoint or the
// reduced-motion preference changes.
import { onReady } from '../utils/ready.js';

export function initMarqueeLogos() {
  var MQ = matchMedia('(max-width: 991px)');
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    var units = [];
    ['hero-statement', 'section-hero'].forEach(function (b) {
      [].forEach.call(document.querySelectorAll('.' + b + '__logos-clip'), function (clip) {
        var stripe = clip.querySelector('.' + b + '__logo-stripe');
        if (stripe && stripe.children.length && stripe.children[0].tagName !== 'IMG') {
          units.push({ clip: clip, stripe: stripe, clones: [] });
        }
      });
    });
    if (!units.length) return;
    function on(u) {
      if (u.clones.length || REDUCED.matches) return;
      [].slice.call(u.stripe.children).forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        [].forEach.call(c.querySelectorAll('img'), function (img) {
          img.alt = '';
          img.removeAttribute('loading');
        });
        u.stripe.appendChild(c);
        u.clones.push(c);
      });
      u.clip.classList.add('is-marquee');
    }
    function off(u) {
      u.clip.classList.remove('is-marquee');
      u.clones.forEach(function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });
      u.clones = [];
    }
    function sync() {
      units.forEach(function (u) {
        if (MQ.matches) on(u);
        else off(u);
      });
    }
    MQ.addEventListener('change', sync);
    REDUCED.addEventListener('change', function () {
      units.forEach(off);
      sync();
    });
    sync();
  }

  onReady(init);
}
